<template>
	<v-container fluid class = "pa-0 ma-0">
		<v-row
			dense
		>
			<!-- search -->
			<v-col
				cols = "12"
				
			>
				<v-card outlined>
					
					<v-card-title
						class = "secondary pa-0  pr-1 subtitle-1 black--text text-uppercase"
					>	
						<v-icon 
							 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>
						<v-spacer></v-spacer>
					
						<v-icon 
							
							color  = "blue"
							class  = "mx-1"							
						>
							mdi-play-box-multiple
						</v-icon>
						<strong
							class = "white--text"
						>
							
							{{ $ml.get('playback') }}
						</strong>
						
						<v-spacer></v-spacer>
						
					</v-card-title>
					<v-card-text
						class = "pa-1"
					>
						
						<v-row
							dense
						>
							<template
								v-for = "(item_search, idx_search) of info_search_fields"
							>
								<v-col
									:key  = "idx_search"
									:cols = "item_search.cols.col"
									v-if  = "item_search.visible"

								>
									<v-select
										v-if 		= "item_search.type == 'select'"
										dense
										outlined
										hide-details
										:items 	  	 = "render_listed(item_search.list)"
										:label         = "$ml.get(item_search.text)"
										v-model  	 = "info_search[item_search.key]"
										:item-value	 = "item_search.key_list"
										:item-text 	 = "item_search.text_list"
										:placeholder = "$ml.get(item_search.placeholder)"
										:multiple	 = "item_search.multiple"
										@input 		 = "render_analytic_option(item_search.key, info_search[item_search.key])"

									></v-select>
									<!-- get_list();  -->
									<searcher
										v-if 			   = "item_search.type == 'select_searcher'"
										:info_to_component = "item_search"
										:info_to_list  	   = "render_listed(item_search.list)"
										@receive_info	   = "info_search[item_search.key] = $event"
									></searcher>

									<v-text-field
										dense
										outlined
										:key 			= "item_search.key + idx_search"
										v-model 		= "info_search[item_search.key]"
										:label       	= "$ml.get(item_search.text)"
										:type 			= "item_search.type"
										v-if 			= "item_search.type == 'text' || item_search.type == 'number'"
										@input 			= "v => info_search[item_search.key] = v.toUpperCase()" 
									></v-text-field>
										
									<dates
										v-if 			   = "	item_search.type == 'date_range' 	|| 
																item_search.type == 'time_picker'"
										:info_to_component = "item_search"
										:info_to_dates 	   = "info_search[item_search.key]"
										@receive_info	   = "info_search[item_search.key] = $event"
									></dates>

								    <v-btn
								    	v-if 	= "item_search.type == 'btn'"
								    	@click 	= "actions(item_search.action)"
								    	:color  = "item_search.color"
								    >
								    	{{ $ml.get(item_search.text) }}
								    </v-btn>
								</v-col>
							</template>
						</v-row>
						<v-progress-linear
							indeterminate
							color  = "primary"
							v-show = "loading" 
						></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-col>
			
			
			<!-- list playback -->
			<v-col
				cols = "12"
				v-show 	= "show" 
			
			>
				<v-card 
					outlined
					ref  = "card_segments"
					:height = "currentHeight"
					style="overflow-y: auto;"
				>
					<v-card-text class = "pa-1 py-0" > 
						<v-row
							dense
						>
							<!-- Video Evidence - Lado izquierdo -->
							<v-col
								cols = "6"
								md = "6"
								lg = "6"
							>
								<v-card outlined>
									<v-card-title
										class = "blue-grey darken-1 pa-0 body-2 white--text text-uppercase"
									>	
										<v-icon
											small
											color  = "white"
											class  = "mx-2"
										>
											mdi-video
										</v-icon>
										{{ $ml.get('video_evidence') }}
										<v-spacer></v-spacer>
										<v-btn
											x-small
											icon
											outlined
											v-show = "url_video && !loading_download"
											class  = "mr-1"
											@click = "download_video(url_video, 'video')"
											color  = "white"

										>
											<v-icon
												x-small
												color = "white"
											>
												mdi-download
											</v-icon>
										</v-btn>
										<v-progress-circular
											indeterminate
											v-show = "loading_download"
											color  = "success"								
											class  = "mr-1"
											:size  = "20"								
										></v-progress-circular>
									</v-card-title>
																		<v-card-text class ="pa-0 ma-0"
										:style = "{ height: '400px' }"
									>
									
										<video
											poster	 = "/img/no_signal.jpg"  
											width 	 = "100%" 
											ref   	 = "video_play"
											height   = "350px"
											v-if  	 = "url_video"
											autoplay = "autoplay" 
											controls = "controls" 											
											tabindex = "0"											
											@ended 	 = "start_Playback()"
											@loadeddata   = "onResize()"
											style = "object-fit: contain; max-height: 100%;"
										>
											<!-- ontimeupdate  = "" -->
									
											<source 
											 	:src = "url_video"
											   	type = 'video/mp4' 
											/>
										</video>
									</v-card-text>
								</v-card>
							</v-col>

							<!-- Video Segments - Lado derecho -->
							<v-col
								cols = "6"
								md = "6"
								lg = "6"
							>
								<v-card outlined>
									<v-card-title
										class = "blue-grey darken-1 pa-0 body-2 white--text text-uppercase"
									>	
										<v-icon
											small
											color  = "white"
											class  = "mx-2"
										>
											mdi-pound-box
										</v-icon>
										{{ $ml.get('video_segments') }}
										<v-spacer></v-spacer>
										<!-- Botón de descarga directo -->
										<v-btn
											color="primary"
											class="text-none mr-1"
											x-small
											v-show="videoTimeline && videoTimeline.length > 0"
											@click="download_video(videoTimeline, 'all')"
										>
											<v-icon x-small class="mr-1">mdi-download</v-icon>
											{{ $ml.get('download') }} : {{ $ml.get('current_videos') }}
										</v-btn>
										
										<!-- Menú original como fallback -->
										<menus
											:info_to_component 		= "info_menu.head"
											:options_to_component 	= "info_menu.options"
											:list_to_component 		= "options_downloads"
											:selected_to_component 	= "downloads.text"
											ref_to_component 		= "download_select"
											:show_menu_component  	= "false"
											@receive_info 			= "actions('set_type_download', $event)"
										></menus>
									</v-card-title>
									<v-card-text 
										class ="pa-2"
										:style = "{ height: '350px', overflowY: 'auto' }"
									>
										<v-item-group 
											return-object
											:multiple 	= "downloads.type == 'select'" 
											v-model 	= "selects" 
										>
											<v-container fluid 
												class 	= "pt-0 pb-1 pt-1"  
												id  	= "scroll-target"  
											> 
												<v-row 
													dense
												>
													<v-col 
														v-for 	= "(item_video, index_video) of videoTimeline" 
														@click 	= "sel(item_video, index_video, downloads.type == 'select')" 
														:key 	= "index_video" 
														xl 		= "6" 
														lg  	= "6" 
														md 		= "6" 
														sm 		= "12" 
														cols 	= "12"  
														class	= "video-grid-item"
													>
														<v-item v-slot:default = "{ active, toggle }">
															<v-card 
																dark  
																outlined
																@click = "toggle" 
																class  = "video-segment-card" 
																:color = "active || item_video.active ? 'primary' : '' "  
															>
																<v-card-subtitle class="video-timestamp">
																	{{ $momentz(parseInt(item_video.date,10)).format('ll, LTS') }}
																</v-card-subtitle>
																<v-card-text class="pa-1">
																	<div class="video-container">
																		<video  
																			class="video-thumbnail"
																			poster="/img/no_signal.jpg"
																			preload="none"
																			:id="'video_event' + index_video"					
																			v-show="!item_video.ready"
																			:data-lazy-src="item_video.urlpath ? `${$URL}${item_video.urlpath}#t=0.5` : ''"
																			:data-video-index="index_video"
																			v-if="item_video.urlpath"
																		>
																			<!-- Source element initially with data URL to prevent warnings -->
																			<source src="data:video/mp4;base64," type="video/mp4" />
														</video>
														
														<!-- Loading indicator for lazy loading -->
														<div class="lazy-loading-indicator" v-if="item_video.loading">
															<v-progress-circular
																indeterminate
																color="primary"
																size="24"
															></v-progress-circular>
															<span class="loading-text">{{ $ml.get('loading_video') }}</span>
														</div>
															
														<!-- Error indicator -->
														<div class="lazy-error-indicator" v-if="item_video.error">
															<v-icon color="error" size="24">mdi-alert-circle</v-icon>
															<span class="error-text">{{ $ml.get('video_load_error') }}</span>
														</div>
														
														<!-- No URL placeholder -->
														<div class="no-url-placeholder" v-if="!item_video.urlpath">
															<v-icon color="grey" size="32">mdi-video-off</v-icon>
															<span class="no-url-text">{{ $ml.get('no_video_available') }}</span>
														</div>
														
														<img
															class="video-placeholder"
															src="/img/no_img_found.png"
															v-show="item_video.ready && item_video.urlpath"
														/>
													</div>
												</v-card-text>			             
											</v-card>
										</v-item>
									</v-col>
								</v-row>	
							</v-container>
						</v-item-group>
									</v-card-text>
									<!-- Paginador siempre visible fuera del scroll -->
									<v-bottom-navigation
										dense
										height="35"
										class="pa-1"
									>
										<v-btn
											text
											:disabled="true"
										>
											<span>
												{{ $ml.get('number_items') }}:
												{{ pagination.items }}
											</span>
										</v-btn>
										<v-pagination
											v-model="page"
											:length="pagination.total"
											:total-visible="pagination.visible"
											dense
											@input="onPageChange"
										></v-pagination>
									</v-bottom-navigation>
				</v-card>
							</v-col>
						</v-row>

						<!-- Timeline - Debajo de los videos -->
						<v-row
							dense
						>
							<v-col
								cols = "6"
								md = "6"
								lg = "6"
							>
								<v-card outlined>
									<v-card-title
										class = "blue-grey darken-1 pa-0 body-2 white--text text-uppercase"
									>	
										<v-icon
											small
											color  = "white"
											class  = "mx-2"
										>
											mdi-timeline
										</v-icon>
										{{ $ml.get('timeline') }}
									</v-card-title>
										<v-card-text class="pa-1">						
											<TimelinePlayback
												ref = "timelinePlayback"
												:search = "searchTimeline"
												:srcImgToComponent = "src_img"
												:urlVideoToComponent = "url_video"
												:refVideoPlayToComponent = "videoPlayerRef"
												@receive_url_video = "url_video = $event"
												@receive_src_img = "src_img = $event"
												@timeline_range_changed = "syncDateControlsWithTimeline($event)"
												@timeline_item_hover = "handleTimelineItemHover($event)"
												@lpr_event_clicked = "handleLPREventClick($event)"
												@alert_event_clicked = "handleAlertEventClick($event)"
												@smart_event_clicked = "handleSmartEventClick($event)"
												@object_event_clicked = "handleObjectEventClick($event)"
												@axle_event_clicked = "handleAxleClick($event)"
												@counter_event_clicked = "handleCounterClick($event)"
												@recording_selected = "handleRecordingClick($event)"
												@items-updated = "handleItemsUpdated($event)"
											></TimelinePlayback>
										</v-card-text>
								</v-card>
							</v-col>
							<!-- Information of timeline  -->
							<v-col
								cols = "6"
								md = "6"
								lg = "6"
							>
								<v-card outlined>
									<v-card-title
										class = "blue-grey darken-1 pa-0 body-2 white--text text-uppercase"
									>	
										<v-icon
											small
											color  = "white"
											class  = "mx-2"
										>
											mdi-timeline
										</v-icon>
										{{ $ml.get('information') }}
									</v-card-title>
																		<v-card-text class="pa-1">						
										<div v-if="timelineHoverInfo">
											<!-- Información del item hovered -->
											<div class="timeline-info-section">
												
												<h6 class="text-h6 mb-2">{{ timelineHoverInfo.item.content}}</h6>
												
												<!-- Información básica - Solo mostrar si NO es layout de 2 columnas -->
												<div v-if="!shouldShowTwoColumnLayout(timelineHoverInfo.item)">
											<div class="info-row">
												<v-icon small class="mr-2">mdi-clock-outline</v-icon>
												<span class="text-body-2">
													<strong>{{ $ml.get('date') }}:</strong> {{ formatTimelineDate(timelineHoverInfo.item.start) }}
												</span>
											</div>
													
													<div v-if="timelineHoverInfo.item.end" class="info-row">
														<v-icon small class="mr-2">mdi-clock-end</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('end') }}:</strong> {{ formatTimelineDate(timelineHoverInfo.item.end) }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.duration" class="info-row">
														<v-icon small class="mr-2">mdi-timer</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('duration') }}:</strong> {{ timelineHoverInfo.item.duration }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.start && timelineHoverInfo.item.end" class="info-row">
														<v-icon small class="mr-2">mdi-timer</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('duration') || 'Duration' }}:</strong> {{ formatDuration(timelineHoverInfo.item.end.getTime() - timelineHoverInfo.item.start.getTime()) }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.metadata && (timelineHoverInfo.item.metadata.eventCount || timelineHoverInfo.item.metadata.isBucket)" class="info-row">
														<v-icon small class="mr-2">mdi-counter</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('events_count') || 'Events Count' }}:</strong> {{ timelineHoverInfo.item.metadata.eventCount || timelineHoverInfo.item.metadata.cantidadEventos || 'N/A' }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.count" class="info-row">
														<v-icon small class="mr-2">mdi-counter</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('count') }}:</strong> {{ timelineHoverInfo.item.count.toLocaleString() }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.type" class="info-row">
														<v-icon small class="mr-2">mdi-tag</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('type') }}:</strong> {{ timelineHoverInfo.item.type }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.density" class="info-row">
														<v-icon small class="mr-2">mdi-chart-line</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('density') }}:</strong> {{ timelineHoverInfo.item.density }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.metadata && timelineHoverInfo.item.metadata.subgroup" class="info-row">
														<v-icon small class="mr-2">mdi-folder</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('subgroup') || 'Subgroup' }}:</strong> {{ timelineHoverInfo.item.metadata.subgroup }}
														</span>
													</div>
													
													<!-- Información del grupo -->
													<div v-if="timelineHoverInfo.group" class="info-row">
														<v-icon small class="mr-2">mdi-folder</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('group') }}:</strong> {{ timelineHoverInfo.group.content }}
														</span>
													</div>
												</div>
												
												<!-- Layout de 2 columnas para Alert, Smart Event y LPR -->
												<div v-if="shouldShowTwoColumnLayout(timelineHoverInfo.item)" class="mt-3">
													<h6 class="text-subtitle-2 mb-2">{{ $ml.get('event_details') }}</h6>
													<div class="two-column-layout">
														<!-- Columna 1: Imagen/Evidencia -->
														<div class="evidence-column">
															<div class="evidence-image-container">
																<img 
																	:src="currentEvidenceUrl" 
																	:alt="getEventType(timelineHoverInfo.item) + ' Evidence'"
																	class="evidence-image"
																	@load="onImageLoad"
																	@error="handleImageError"
																	loading="lazy"
																/>
															</div>
														</div>
														
														<!-- Columna 2: Información del evento -->
														<div class="event-info-column">
															<div class="event-details">
																<div class="event-type-badge">
																	<v-icon :color="getEventColor(timelineHoverInfo.item)" class="mr-2">
																		{{ getEventIcon(timelineHoverInfo.item) }}
																	</v-icon>
																	<span class="event-type-text">{{ getEventType(timelineHoverInfo.item) }}</span>
																</div>
																
																<div class="event-meta-info">
																	<div class="info-row">
																		<v-icon small class="mr-2">mdi-clock-outline</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('start_time') || 'Start Time' }}:</strong> {{ formatTimelineDate(timelineHoverInfo.item.start) }}
																		</span>
																	</div>
																	
																	<div v-if="timelineHoverInfo.item.end" class="info-row">
																		<v-icon small class="mr-2">mdi-clock-end</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('end_time') || 'End Time' }}:</strong> {{ formatTimelineDate(timelineHoverInfo.item.end) }}
																		</span>
																	</div>
																	
																	<div v-if="timelineHoverInfo.item.start && timelineHoverInfo.item.end" class="info-row">
																		<v-icon small class="mr-2">mdi-timer</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('duration') || 'Duration' }}:</strong> {{ formatDuration(timelineHoverInfo.item.end.getTime() - timelineHoverInfo.item.start.getTime()) }}
																		</span>
																	</div>
																	
																	<div v-if="timelineHoverInfo.item.metadata && (timelineHoverInfo.item.metadata.eventCount || timelineHoverInfo.item.metadata.isBucket)" class="info-row">
																		<v-icon small class="mr-2">mdi-counter</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('events_count') || 'Events Count' }}:</strong> {{ timelineHoverInfo.item.metadata.eventCount || timelineHoverInfo.item.metadata.cantidadEventos || 'N/A' }}
																		</span>
																	</div>
																	
																	<div v-if="timelineHoverInfo.item.metadata && timelineHoverInfo.item.metadata.alertType" class="info-row">
																		<v-icon small class="mr-2">mdi-tag</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('type') }}:</strong> {{ timelineHoverInfo.item.metadata.alertType }}
																		</span>
																	</div>
																	
																	<div v-if="timelineHoverInfo.item.metadata && timelineHoverInfo.item.metadata.subgroup" class="info-row">
																		<v-icon small class="mr-2">mdi-folder</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('subgroup') }}:</strong> {{ timelineHoverInfo.item.metadata.subgroup }}
																		</span>
																	</div>
																	
																	<div v-if="timelineHoverInfo.item.id" class="info-row">
																		<v-icon small class="mr-2">mdi-identifier</v-icon>
																		<span class="text-body-2">
																			<strong>{{ $ml.get('id') }}:</strong> {{ timelineHoverInfo.item.id }}
																		</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												
												<!-- Información adicional - Solo mostrar si NO es layout de 2 columnas -->
												<div v-if="timelineHoverInfo.item.metadata && !shouldShowTwoColumnLayout(timelineHoverInfo.item)" class="mt-3">
													<h6 class="text-subtitle-2 mb-2">{{ $ml.get('additional_information') }}</h6>
													
													<div v-if="timelineHoverInfo.item.metadata.peakTime" class="info-row">
														<v-icon small class="mr-2">mdi-chart-bell-curve</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('peak_time') }}:</strong> {{ formatTimelineDate(timelineHoverInfo.item.metadata.peakTime) }}
														</span>
													</div>
													
													<div v-if="timelineHoverInfo.item.metadata.objectTypes" class="info-row">
														<v-icon small class="mr-2">mdi-shape</v-icon>
														<span class="text-body-2">
															<strong>{{ $ml.get('object_types') }}:</strong> {{ timelineHoverInfo.item.metadata.objectTypes.join(', ') }}
														</span>
													</div>
													
													<!-- Información específica de Objects -->
													<div v-if="timelineHoverInfo.item.metadata.isObject" class="mt-2">
														<div v-if="timelineHoverInfo.item.metadata.eventCount || timelineHoverInfo.item.metadata.isBucket" class="info-row">
															<v-icon small class="mr-2">mdi-counter</v-icon>
															<span class="text-body-2">
																<strong>{{ $ml.get('events_count') || 'Events Count' }}:</strong> {{ timelineHoverInfo.item.metadata.eventCount || timelineHoverInfo.item.metadata.cantidadEventos || 'N/A' }}
															</span>
														</div>
													</div>
													
													<!-- Información específica de Smart Events -->
													<div v-if="timelineHoverInfo.item.metadata.smartEvent" class="mt-2">
														<div v-if="timelineHoverInfo.item.metadata.smartEvent.deviceId" class="info-row">
															<v-icon small class="mr-2">mdi-camera</v-icon>
															<span class="text-body-2">
																<strong>{{ $ml.get('device_id') }}:</strong> {{ timelineHoverInfo.item.metadata.smartEvent.deviceId }}
															</span>
														</div>
														
														
													</div>
												</div>
											</div>
										</div>
										
										<!-- Gráfica de distribución temporal de eventos -->
										<div v-else>
											<EventsChart 
												:events="timelineItems" 
												:time-range="timelineRange"
											/>
										</div>
									</v-card-text>
								</v-card>
							</v-col>
							
						</v-row>
					</v-card-text>					
				</v-card>
			</v-col>			
		</v-row>

		<!-- Modal LPR Alert -->
            <LPRAlertModal
                ref="lprModal"
                :isVisible="showLPRModal"
                :eventData="lprEventData"
                :currentIndex="currentLPRIndex"
                :totalEvents="totalLPREvents"
                :canNavigatePrevious="canNavigateLPRPrevious"
                :canNavigateNext="canNavigateLPRNext"
                @close="closeLPRModal"
                @search-video="searchVideoForLPR"
                @open-video-in-main-player="openVideoInMainPlayer"
                @navigate-previous="navigateToPreviousLPR"
                @navigate-next="navigateToNextLPR"
            ></LPRAlertModal>
            
            <AlertSmartEventModal
                ref="alertSmartEventModal"
                :isVisible="showAlertSmartEventModal"
                :eventData="alertSmartEventData"
                :bucketEvents="alertSmartEventBucketEvents"
                :loadingEvents="alertSmartEventLoadingEvents"
                :currentIndex="currentAlertSmartIndex"
                :totalEvents="totalAlertSmartEvents"
                :canNavigatePrevious="canNavigateAlertSmartPrevious"
                :canNavigateNext="canNavigateAlertSmartNext"
                @close="closeAlertSmartEventModal"
                @search-video="searchVideoForAlertSmartEvent"
                @open-video-in-main-player="openVideoInMainPlayer"
                @navigate-previous="navigateToPreviousAlertSmart"
                @navigate-next="navigateToNextAlertSmart"
            ></AlertSmartEventModal>

            <!-- Modal para Object Events -->
            <v-dialog
                v-model="showObjectModal"
                max-width="600px"
                persistent
            >
                <v-card>
                    <v-card-title class="headline blue-grey darken-1 white--text">
                        <v-icon class="mr-2">mdi-target</v-icon>
                        {{ $ml.get('object_detected') || 'Object Detected' }}
                        
                        <!-- Navegación entre eventos -->
                        <div class="event-navigation ml-4">
                            <v-btn
                                icon
                                small
                                @click="navigateToPreviousObject"
                                :disabled="!canNavigatePrevious"
                                color="white"
                                class="mr-1"
                            >
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            
                            <span class="navigation-info">
                                {{ currentObjectIndex + 1 }} / {{ totalObjectsInCategory }}
                            </span>
                            
                            <v-btn
                                icon
                                small
                                @click="navigateToNextObject"
                                :disabled="!canNavigateNext"
                                color="white"
                                class="ml-1"
                            >
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                        
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="closeObjectModal"
                            color="white"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    
                    <v-card-text class="pa-4">
                        <div v-if="objectEventData">
                            <!-- Información del objeto -->
                            <div class="info-section">
                                <h4 class="mb-3">{{ $ml.get('object_information') || 'Object Information' }}</h4>
                                
                                <div class="info-item">
                                    <v-icon small class="mr-2">mdi-tag</v-icon>
                                    <strong>{{ $ml.get('type') || 'Type' }}:</strong> 
                                    <span class="ml-2">{{ objectEventData.metadata?.objectType || 'Unknown' }}</span>
                                </div>
                                
                                <div class="info-item">
                                    <v-icon small class="mr-2">mdi-identifier</v-icon>
                                    <strong>{{ $ml.get('id') || 'ID' }}:</strong> 
                                    <span class="ml-2">{{ objectEventData.metadata?.objectId || 'N/A' }}</span>
                                </div>
                                
                                <div class="info-item" v-if="objectEventData.metadata?.confidence">
                                    <v-icon small class="mr-2">mdi-chart-line</v-icon>
                                    <strong>{{ $ml.get('confidence') || 'Confidence' }}:</strong> 
                                    <span class="ml-2">{{ (objectEventData.metadata.confidence * 100).toFixed(1) }}%</span>
                                </div>
                                
                                <div class="info-item" v-if="objectEventData.metadata?.subgroup">
                                    <v-icon small class="mr-2">mdi-folder</v-icon>
                                    <strong>{{ $ml.get('subgroup') || 'Subgroup' }}:</strong> 
                                    <span class="ml-2">{{ objectEventData.metadata.subgroup }}</span>
                                </div>
                                
                                <div class="info-item">
                                    <v-icon small class="mr-2">mdi-clock-outline</v-icon>
                                    <strong>{{ $ml.get('start_time') || 'Start Time' }}:</strong> 
                                    <span class="ml-2">{{ formatTimelineDate(objectEventData.start) }}</span>
                                </div>
                                
                                <div class="info-item" v-if="objectEventData.end">
                                    <v-icon small class="mr-2">mdi-clock-end</v-icon>
                                    <strong>{{ $ml.get('end_time') || 'End Time' }}:</strong> 
                                    <span class="ml-2">{{ formatTimelineDate(objectEventData.end) }}</span>
                                </div>
                                
                                <div class="info-item" v-if="objectEventData.start && objectEventData.end">
                                    <v-icon small class="mr-2">mdi-timer</v-icon>
                                    <strong>{{ $ml.get('duration') || 'Duration' }}:</strong> 
                                    <span class="ml-2">{{ formatDuration(objectEventData.end.getTime() - objectEventData.start.getTime()) }}</span>
                                </div>
                                
                                <div class="info-item" v-if="objectEventData.metadata && (objectEventData.metadata.eventCount || objectEventData.metadata.isBucket)">
                                    <v-icon small class="mr-2">mdi-counter</v-icon>
                                    <strong>{{ $ml.get('events_count') || 'Events Count' }}:</strong> 
                                    <span class="ml-2">{{ objectEventData.metadata.eventCount || objectEventData.metadata.cantidadEventos || 'N/A' }}</span>
                                </div>
                                
                                <!-- Bounding box info -->
                                <div v-if="objectEventData.metadata?.bbox" class="bbox-info mt-3">
                                    <h5>{{ $ml.get('bounding_box') || 'Bounding Box' }}</h5>
                                    <div class="bbox-coordinates">
                                        <div>X: {{ objectEventData.metadata.bbox[0] }}</div>
                                        <div>Y: {{ objectEventData.metadata.bbox[1] }}</div>
                                        <div>Width: {{ objectEventData.metadata.bbox[2] }}</div>
                                        <div>Height: {{ objectEventData.metadata.bbox[3] }}</div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Video relacionado -->
                            <div class="video-section mt-4">
                                <h4 class="mb-3">{{ $ml.get('related_video') || 'Related Video' }}</h4>
                                
                                <!-- Loading state -->
                                <div v-if="objectVideoLoading" class="video-loading">
                                    <v-progress-circular
                                        indeterminate
                                        color="primary"
                                        size="24"
                                    ></v-progress-circular>
                                    <span class="ml-2">{{ $ml.get('searching_video') || 'Searching for video...' }}</span>
                                </div>
                                
                                <!-- Video found -->
                                <div v-else-if="objectVideoData" class="video-found">
                                    <div class="video-info mb-3">
                                        <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                                        <span>{{ $ml.get('video_found') || 'Video found' }}</span>
                                    </div>
                                    
                                    <!-- Video player in modal -->
                                    <div class="modal-video-player">
                                        <video
                                            :src="objectVideoData.videoUrl"
                                            controls
                                            class="modal-video"
                                            @loadeddata="onObjectVideoLoaded"
                                            @error="onObjectVideoError"
                                        >
                                            <source :src="objectVideoData.videoUrl" type="video/mp4">
                                            {{ $ml.get('video_not_supported') || 'Your browser does not support the video tag.' }}
                                        </video>
                                    </div>
                                    
                                    <!-- Action buttons -->
                                    <div class="video-actions mt-3">
                                        <v-btn
                                            color="primary"
                                            @click="openObjectVideoInMainPlayer"
                                            class="mr-2"
                                        >
                                            <v-icon class="mr-2">mdi-play</v-icon>
                                            {{ $ml.get('play_in_main_player') || 'Play in Main Player' }}
                                        </v-btn>
                                        
                                        <v-btn
                                            color="secondary"
                                            @click="downloadObjectVideo"
                                            v-if="objectVideoData.videoUrl"
                                        >
                                            <v-icon class="mr-2">mdi-download</v-icon>
                                            {{ $ml.get('download') || 'Download' }}
                                        </v-btn>
                                    </div>
                                </div>
                                
                                <!-- No video found -->
                                <div v-else-if="objectVideoError" class="video-error">
                                    <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                                    <span>{{ $ml.get('video_not_found') || 'No video found for this event' }}</span>
                                </div>
                                
                                <!-- No video searched yet -->
                                <div v-else class="video-not-searched">
                                    <v-icon color="grey" class="mr-2">mdi-video-off</v-icon>
                                    <span>{{ $ml.get('video_not_searched') || 'Video search not initiated' }}</span>
                                    <v-btn
                                        small
                                        color="primary"
                                        @click="searchVideoManually"
                                        class="mt-2"
                                    >
                                        <v-icon small class="mr-1">mdi-magnify</v-icon>
                                        {{ $ml.get('search_video') || 'Search Video' }}
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="grey"
                            text
                            @click="closeObjectModal"
                        >
                            {{ $ml.get('close') || 'Close' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
	</v-container>
</template>

<script  src="./js/playback.js"></script>

<style scoped>
/* Pestañas con relieve y división */
.tabs-with-relief {
	border-bottom: 2px solid rgba(255, 255, 255, 0.1) !important;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
}

/* Pestañas con texto en mayúsculas y estilo correcto */
.v-tab {
	text-transform: uppercase !important;
	font-size: 12px !important;
	font-weight: bold !important;
	min-height: 36px !important;
	height: 36px !important;
	letter-spacing: 0.5px !important;
}

/* Video Segments Grid Styling */
.video-grid-item {
	padding: 2px !important;
}

.video-segment-card {
	margin: 0 !important;
	height: 100% !important;
	transition: all 0.2s ease !important;
	background: rgba(50, 50, 50, 0.9) !important;
}

.video-segment-card:hover {
	transform: scale(1.02) !important;
	box-shadow: 0 2px 8px rgba(0,0,0,0.5) !important;
	z-index: 2 !important;
}

.video-timestamp {
	font-size: 10px !important;
	line-height: 1.1 !important;
	padding: 2px 4px !important;
	background: rgba(0,0,0,0.8) !important;
	text-align: center !important;
	margin: 0 !important;
	color: #fff !important;
	font-weight: 500 !important;
}

.video-container {
	position: relative !important;
	width: 100% !important;
	aspect-ratio: 16/9 !important;
	background: #000 !important;
	border-radius: 2px !important;
	overflow: hidden !important;
	min-height: 80px !important;
}

.video-thumbnail {
	width: 100% !important;
	height: 100% !important;
	object-fit: cover !important;
	border-radius: 2px !important;
}

.video-placeholder {
	width: 100% !important;
	height: 100% !important;
	object-fit: cover !important;
	border-radius: 2px !important;
	opacity: 0.8 !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	background: #1a1a1a !important;
	color: #666 !important;
	font-size: 12px !important;
	text-align: center !important;
}

/* Lazy loading indicators */
.lazy-loading-indicator,
.lazy-error-indicator {
	position: absolute !important;
	top: 50% !important;
	left: 50% !important;
	transform: translate(-50%, -50%) !important;
	display: flex !important;
	flex-direction: column !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 8px !important;
	z-index: 10 !important;
	background: rgba(0, 0, 0, 0.7) !important;
	padding: 12px !important;
	border-radius: 8px !important;
	backdrop-filter: blur(4px) !important;
}

.loading-text,
.error-text {
	color: #fff !important;
	font-size: 10px !important;
	font-weight: 500 !important;
	text-align: center !important;
}

.lazy-error-indicator .error-text {
	color: #f44336 !important;
}

/* No URL placeholder */
.no-url-placeholder {
	position: absolute !important;
	top: 50% !important;
	left: 50% !important;
	transform: translate(-50%, -50%) !important;
	display: flex !important;
	flex-direction: column !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 8px !important;
	z-index: 10 !important;
	background: rgba(0, 0, 0, 0.8) !important;
	padding: 16px !important;
	border-radius: 8px !important;
	backdrop-filter: blur(4px) !important;
	width: 80% !important;
	height: 60% !important;
}

.no-url-text {
	color: #9e9e9e !important;
	font-size: 10px !important;
	font-weight: 500 !important;
	text-align: center !important;
}

/* Estilos para la información del timeline - Diseño Moderno Oscuro */
.timeline-info-section {
	padding: 20px;
	background: #1e1e1e;
	border-radius: 12px;
	margin: 8px 0;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
	border: 1px solid rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(20px);
}

/* Estilos para el mensaje cuando no hay información */
.timeline-info-section .text-center {
	color: #9e9e9e;
	text-align: center;
	padding: 40px 20px;
}

.timeline-info-section .text-center .v-icon {
	color: #616161;
	font-size: 48px;
	margin-bottom: 16px;
}

.timeline-info-section .text-center .text-body-2 {
	color: #9e9e9e;
	font-size: 14px;
	line-height: 1.6;
}

.timeline-info-section h6 {
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 16px;
	font-size: 18px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.info-row {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	padding: 8px 12px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 6px;
	border-left: 3px solid #1976D2;
	transition: all 0.2s ease;
}

.info-row:hover {
	background: rgba(255, 255, 255, 0.08);
	transform: translateX(4px);
}

.info-row:last-child {
	margin-bottom: 0;
}

.info-row .v-icon {
	color: #64b5f6;
	flex-shrink: 0;
	margin-right: 12px;
	font-size: 18px;
}

.info-row span {
	color: #e0e0e0;
	font-size: 14px;
	line-height: 1.5;
	font-weight: 400;
}

.info-row strong {
	color: #64b5f6;
	font-weight: 600;
	margin-right: 8px;
}

/* Estilos para la información adicional */
.timeline-info-section .text-subtitle-2 {
	color: #90caf9;
	font-weight: 600;
	margin-bottom: 16px;
	padding-top: 20px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	font-size: 16px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	position: relative;
}

.timeline-info-section .text-subtitle-2::before {
	content: '';
	position: absolute;
	top: -1px;
	left: 0;
	right: 0;
	height: 2px;
	background: linear-gradient(90deg, #90caf9, #1976d2);
	border-radius: 1px;
}

/* Estilos para la imagen de evidence - Diseño Oscuro */
.evidence-image-container {
	text-align: center;
	margin: 16px 0;
	padding: 16px;
	background: rgba(255, 255, 255, 0.03);
	border-radius: 8px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(10px);
}

.evidence-image {
	max-width: 100%;
	max-height: 200px;
	border-radius: 8px;
	border: 2px solid #4caf50;
	box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
	transition: all 0.3s ease;
}

/* Estilos para el layout de 2 columnas */
.two-column-layout {
	display: flex;
	gap: 20px;
	align-items: flex-start;
	max-height: 300px;
	overflow: hidden;
}

.evidence-column {
	flex: 0 0 250px;
	min-width: 250px;
	max-width: 250px;
}

.event-info-column {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
}

.event-details {
	background: rgba(255, 255, 255, 0.03);
	border-radius: 8px;
	padding: 12px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	height: 100%;
	display: flex;
	flex-direction: column;
}

.event-type-badge {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	padding: 6px 10px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 6px;
	border-left: 4px solid;
	flex-shrink: 0;
}

.event-type-text {
	font-weight: 600;
	font-size: 13px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.event-meta-info {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px 16px;
	flex: 1;
	overflow: hidden;
}

.event-meta-info .info-row {
	display: flex;
	align-items: center;
	padding: 2px 0;
	min-height: 20px;
}

.event-meta-info .info-row .v-icon {
	margin-right: 6px;
	flex-shrink: 0;
	font-size: 14px;
}

.event-meta-info .info-row .text-body-2 {
	flex: 1;
	min-width: 0;
	word-break: break-word;
	font-size: 11px;
	line-height: 1.2;
}

/* Responsive design para pantallas pequeñas */
@media (max-width: 768px) {
	.two-column-layout {
		flex-direction: column;
		gap: 16px;
		max-height: none;
	}
	
	.evidence-column {
		flex: none;
		min-width: auto;
		max-width: none;
	}
	
	.evidence-image {
		max-height: 150px;
	}
	
	.event-meta-info {
		grid-template-columns: 1fr;
		gap: 4px;
	}
}

.evidence-image:hover {
	transform: scale(1.05);
	box-shadow: 0 8px 24px rgba(76, 175, 80, 0.4);
	border-color: #66bb6a;
}

/* Estilos para mensajes de error de imagen - Diseño Oscuro */
.image-error-message {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 20px;
	color: #ffcdd2;
	background: rgba(244, 67, 54, 0.1);
	border-radius: 8px;
	border: 1px dashed #f44336;
	backdrop-filter: blur(10px);
}

.image-error-message .v-icon {
	margin-right: 8px;
	color: #f44336;
	font-size: 20px;
}

/* Estilos para el modal de objetos */
.info-section {
	background: rgba(255, 255, 255, 0.05);
	border-radius: 8px;
	padding: 16px;
	border: 1px solid rgba(255, 255, 255, 0.1);
}

.info-item {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	padding: 8px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.info-item:last-child {
	border-bottom: none;
	margin-bottom: 0;
}

.info-item .v-icon {
	color: #64b5f6;
	margin-right: 8px;
}

.info-item strong {
	color: #90caf9;
	margin-right: 8px;
}


.bbox-info {
	background: rgba(255, 255, 255, 0.03);
	border-radius: 6px;
	padding: 12px;
	border: 1px solid rgba(255, 255, 255, 0.1);
}

.bbox-coordinates {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px;
	margin-top: 8px;
}

.bbox-coordinates div {
	font-size: 12px;
	color: #e0e0e0;
}

.video-section {
	background: rgba(255, 255, 255, 0.05);
	border-radius: 8px;
	padding: 16px;
	border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Estilos para el reproductor de video en el modal */
.video-loading {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	color: #90caf9;
}

.video-found {
	text-align: center;
}

.video-info {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #4caf50;
	font-weight: 500;
}

.modal-video-player {
	background: #000;
	border-radius: 8px;
	overflow: hidden;
	margin: 16px 0;
	border: 2px solid #4caf50;
	box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
}

.modal-video {
	width: 100%;
	max-height: 300px;
	object-fit: contain;
	display: block;
}

.video-actions {
	display: flex;
	justify-content: center;
	gap: 12px;
	flex-wrap: wrap;
}

.video-error {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	color: #f44336;
	background: rgba(244, 67, 54, 0.1);
	border-radius: 8px;
	border: 1px dashed #f44336;
}

.video-not-searched {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	color: #9e9e9e;
	background: rgba(255, 255, 255, 0.03);
	border-radius: 8px;
	border: 1px dashed #666;
}

/* Estilos para la navegación de eventos */
.event-navigation {
	display: flex;
	align-items: center;
	gap: 8px;
}

.navigation-info {
	font-size: 12px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.8);
	min-width: 40px;
	text-align: center;
}
</style>

<script>
import playbackLogic from './js/playback.js';
import EventsChart from '@/components/analytics/EventsChart.vue';

export default {
	...playbackLogic,
	components: {
		...playbackLogic.components,
		EventsChart
	},
	data() {
		return {
			...playbackLogic.data(this),
			timelineItems: [],
			timelineRange: {
				start: null,
				end: null
			}
		};
	},
	computed: {
		...playbackLogic.computed
	},
	methods: {
		...playbackLogic.methods,
		onPageChange() {
			if (this.intersectionObserver) {
				this.intersectionObserver.disconnect();
			}
			this.get_list();
		},
		handleItemsUpdated(items) {
			// Optimización: Usar referencia directa en lugar de crear copias para evitar duplicación de memoria
			// Solo crear copias ligeras si realmente es necesario para la gráfica
			if (!items || items.length === 0) {
				this.timelineItems = [];
				return;
			}
			
			// Limitar a máximo 5000 items para evitar consumo excesivo de memoria
			const maxItems = 5000;
			const itemsToProcess = items.length > maxItems ? items.slice(0, maxItems) : items;
			// Crear una copia ultra-ligera solo con datos absolutamente esenciales para la gráfica
			// Usar for loop en lugar de map para mejor rendimiento
			const timelineItems = [];
			const itemsLength = itemsToProcess.length;
			
			for (let i = 0; i < itemsLength; i++) {
				const item = itemsToProcess[i];
				if (!item) continue;
				
				const metadata = item.metadata || {};
				// Crear objeto mínimo solo con lo esencial
				timelineItems.push({
					id: item.id,
					group: item.group,
					start: item.start,
					end: item.end,
					metadata: {
						isBucket: metadata.isBucket || false,
						eventCount: metadata.eventCount || metadata.cantidadEventos || null,
						isObject: metadata.isObject || false,
						isSmartEvent: metadata.isSmartEvent || false,
						isAlert: metadata.isAlert || false,
						objectType: metadata.objectType || null,
						category: metadata.category || null
					}
				});
			}
			
			this.timelineItems = timelineItems;
		},
		formatDuration(ms) {
			if (!ms || ms < 0) return '0s';
			const seconds = Math.floor(ms / 1000);
			const minutes = Math.floor(seconds / 60);
			const hours = Math.floor(minutes / 60);
			const days = Math.floor(hours / 24);
			
			if (days > 0) return `${days}d ${hours % 24}h ${minutes % 60}m`;
			if (hours > 0) return `${hours}h ${minutes % 60}m`;
			if (minutes > 0) return `${minutes}m ${seconds % 60}s`;
			return `${seconds}s`;
		}
	}
};
</script>
